import { protectedGet } from "./restUtil";
import moment from "moment";

export class NotificationTaskType {
  static FEEDBACK = "feedback-task";
  static PLAN = "plan-task";
}

export function fetchTasksNumber(args, onSuccess, onError) {
  return protectedGet(
    "/tasks/count",
    undefined,
    resp => {
      if (!resp || resp.count === undefined) {
        return onError && onError("invalid response structure");
      }
      return onSuccess && onSuccess(resp.count);
    },
    onError
  );
}

export function fetchTasks(args, onSuccess, onError) {
  return protectedGet(
    "/tasks",
    undefined,
    resp => {
      if (!resp || resp.list === undefined) {
        return onError && onError("invalid response structure");
      }
      return onSuccess && onSuccess(resp);
    },
    onError
  );
}

export function isTaskOverdue(task) {
  return moment().isAfter(task.due_date);
}
